import { render, staticRenderFns } from "./educationStatusBreachOfPromise.vue?vue&type=template&id=0c72fb7e&"
import script from "./educationStatusBreachOfPromise.vue?vue&type=script&lang=js&"
export * from "./educationStatusBreachOfPromise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports